import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import AddAffiliatePresentational from './add-affiliate-presentational';

import Selectors from '../selectors';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import Actions from '../action';
import { connect } from 'react-redux';
import { appConstant } from '@constants';

const AddAffiliateFunctional = ({
	addAffiliate,
	affiliateStatus,
	addAffiliateLoading,
	addAffiliateResetValues,
	userDetails,
	getCampaignDropdown,
	campaignDDList,
	campaignDDListLoading,
}) => {
	const { type } = useParams();
	const history = useHistory();
	const [affiliate, setaffiliate] = useState({
		userName: '',
		email: '',
		sourceValue1: '',
		sourceValue2: '',
		sourceValue3: '',
		sourceValue4: '',
		sourceValue5: '',
		step1Commission: '',
		step2Commission: '',
		cpcCommission: '',
	});
	const [selectedCampaignList, setSelectedCampaignList] = useState([]);
	useEffect(() => {
		if (affiliateStatus === appConstant.success) {
			history.goBack();
		}
		return () => addAffiliateResetValues();
	}, [affiliateStatus]);

	useEffect(() => {
		getCampaignDropdown(userDetails && userDetails.companyId, history);
	}, []);

	const handleChange = ({ target: { name, value } }) => {
		setaffiliate({
			...affiliate,
			[name]: value,
		});
	};

	const handleAdd = () => {
		addAffiliate({ ...affiliate, campaignId: selectedCampaignList });
	};

	const handleDropdownChange = (value) => {
		setSelectedCampaignList(value);
	};

	return (
		<AddAffiliatePresentational
			handleAdd={handleAdd}
			affiliateStatus={affiliateStatus}
			addAffiliateLoading={addAffiliateLoading}
			affiliate={affiliate}
			handleChange={handleChange}
			type={type}
			history={history}
			userDetails={userDetails}
			campaignDDList={campaignDDList}
			campaignDDListLoading={campaignDDListLoading}
			handleDropdownChange={handleDropdownChange}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		addAffiliateLoading: Selectors.addAffiliateLoading(state),
		affiliateStatus: Selectors.affiliateStatus(state),
		userDetails: SelectorsApp.userDetails(state),
		campaignDDList: Selectors.campaignDDList(state),
		campaignDDListLoading: Selectors.campaignDDListLoading(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addAffiliate: (affiliate) => dispatch(Actions.creators.addAffiliate(affiliate)),
		addAffiliateResetValues: () => dispatch(Actions.creators.addAffiliateResetValues()),
		getCampaignDropdown: (companyId, history) => dispatch(Actions.creators.getCampaignDropdown(companyId, history)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(AddAffiliateFunctional);

export default Connected;
